import { fromJS } from 'immutable';
import * as constants from './constants';

const defaultState = fromJS({
	userName: '',
	userPass: '',
	errUserName: '',
	errUserPass: '',
	isUserName: false,
	isUserPass: false,
	isManuBtnClick: false,
})

export default ( state = defaultState, action ) => {
	switch(action.type) {
		case constants.TOGGLE_USERNAME_ERR:
			return state.merge({
				'isUserName': action.value,
				'errUserName': action.text
			});
		case constants.TOGGLE_PASS_ERR:
			return state.merge({
				'isUserPass': action.value,
				'errUserPass': action.text
			});
		case constants.HANDLE_USERNAME_CHANGE:
			return state.set('userName', action.value);
		case constants.HANDLE_PASSWORD_CHANGE:
			return state.set('userPass', action.value);
		case constants.RESET_FORM:
			return state.merge({
				'userName': '',
				'userPass': '',
				'errUserName': '',
				'errUserPass': '',
				'isUserName': false,
				'isUserPass': false,
			});
		case constants.MANU_BTN_CLICK:
			return state.set('isManuBtnClick', action.value);
		default: 
			return state;
	}
}


